/** Site-wide email address. Used in Footer, AvatarUI contact section and the About panel. */
export const EMAIL = "oliver_hassan@outlook.com";

/** LinkedIn profile. Used in AvatarUI contact section and the About panel. */
export const LINKEDIN_URL = "https://www.linkedin.com/in/oliver-hassan/";

/** ISO date string for age calculation. */
export const BIRTH_DATE = "2000-01-02";

/** Compute current age in whole years from an ISO date string. */
export function getAge(birthDate: string = BIRTH_DATE): number {
    return Math.floor(
        (Date.now() - new Date(birthDate).getTime()) / (1000 * 60 * 60 * 24 * 365.25),
    );
}
